// extracted by mini-css-extract-plugin
export default {"root":"wBnJVYdTpPRHnW_h5yx5","justified":"pWc7DXFa5ud2i2QmWyH8","tag":"Jq3w2yU6_tGnkx4_WobL"};